import dayjs from 'dayjs';

export const REGISTER_STATUSES = {
  active: { label: 'Active', color: 'success' },
  expired: { label: 'Expired', color: 'error' },
  undated: { label: 'No expiry set', color: 'default' },
  unavailable: { label: 'Status unavailable', color: 'default' },
  capacity: { label: 'At capacity', color: 'warning' },
};

export const isRegisterAtCapacity = register => [
  [register.usersUsed, register.userLimit],
  [register.itemsUsed, register.itemLimit],
].some(([count, limit]) => Number.isFinite(Number(count)) && count != null &&
  Number.isFinite(Number(limit)) && Number(limit) > 0 && Number(count) / Number(limit) >= 1);

export const getRegisterStatus = (register, today = dayjs().startOf('day')) => {
  if (register.loadErrors?.includes('expiry')) return 'unavailable';
  if (!register.expiryDate) return 'undated';
  const expiry = dayjs(register.expiryDate);
  if (!expiry.isValid()) return 'unavailable';
  // Use the server's business calendar for expiry. The local
  // calculation only supports older API responses without daysUntilExpiry.
  const daysUntilExpiry = Number.isFinite(register.daysUntilExpiry)
    ? register.daysUntilExpiry : expiry.startOf('day').diff(today.startOf('day'), 'day');
  if (register.isExpired === true || (register.isExpired == null && daysUntilExpiry < 0)) {
    return 'expired';
  }
  return 'active';
};

export const filterRegisters = (registers, { status = 'all', plan = 'all', query = '' } = {}) => {
  const search = query.trim().toLowerCase();
  return registers.filter(register => (
    (status === 'all' || (status === 'capacity' ? isRegisterAtCapacity(register) : getRegisterStatus(register) === status)) &&
    (plan === 'all' || register.planType === plan) &&
    (!search || [register.datname, register.dbCode, register.contractId, register.planType]
      .some(value => String(value || '').toLowerCase().includes(search)))
  ));
};
